import React from 'react';

function DetailLeft() {
  return (
    <div className='mt-10 hidden w-1/4 lg:block'>
      <div className='h-36 w-full rounded-2xl bg-gray-300'></div>
      <div className='h-36 w-full rounded-2xl bg-gray-300 mt-4'></div>
      <div className='h-36 w-full rounded-2xl bg-gray-300 mt-4'></div>
      <div className='h-36 w-full rounded-2xl bg-gray-300 mt-4'></div>
    </div>
  );
}

export default DetailLeft;
